/**
 * Feature status constants
 */
export const FEATURE_STATUS = {
  OPEN: 'open',
  IN_PROGRESS: 'in-progress',
  IN_REVIEW: 'in-review',
  TESTING: 'testing',
  CLOSED: 'closed'
}

export const FEATURE_STATUS_OPTIONS = [
  { value: FEATURE_STATUS.OPEN, label: 'Open' },
  { value: FEATURE_STATUS.IN_PROGRESS, label: 'In Progress' },
  { value: FEATURE_STATUS.IN_REVIEW, label: 'In Review' },
  { value: FEATURE_STATUS.TESTING, label: 'Testing' },
  { value: FEATURE_STATUS.CLOSED, label: 'Closed' }
]

/**
 * Feature priority constants
 */
export const FEATURE_PRIORITY = {
  CRITICAL: 'critical',
  HIGH: 'high',
  MEDIUM: 'medium',
  LOW: 'low'
}

export const FEATURE_PRIORITY_OPTIONS = [
  { value: FEATURE_PRIORITY.CRITICAL, label: 'Critical' },
  { value: FEATURE_PRIORITY.HIGH, label: 'High' },
  { value: FEATURE_PRIORITY.MEDIUM, label: 'Medium' },
  { value: FEATURE_PRIORITY.LOW, label: 'Low' }
]

/**
 * Feature status colors for badges
 */
export const FEATURE_STATUS_COLORS = {
  [FEATURE_STATUS.OPEN]: 'gray',
  [FEATURE_STATUS.IN_PROGRESS]: 'blue',
  [FEATURE_STATUS.IN_REVIEW]: 'yellow',
  [FEATURE_STATUS.TESTING]: 'purple',
  [FEATURE_STATUS.CLOSED]: 'green'
}

/**
 * Feature priority colors for badges
 */
export const FEATURE_PRIORITY_COLORS = {
  [FEATURE_PRIORITY.CRITICAL]: 'red',
  [FEATURE_PRIORITY.HIGH]: 'orange',
  [FEATURE_PRIORITY.MEDIUM]: 'yellow',
  [FEATURE_PRIORITY.LOW]: 'green'
}

/**
 * Feature hierarchy constants
 */
export const MAX_FEATURE_DEPTH = 4 // 0-indexed, so 0-4 = 5 levels (P1 > C1 > C2 > C3 > C4 > C5)

/**
 * Activity types for features
 */
export const FEATURE_ACTIVITY_TYPES = {
  CREATED: 'created',
  UPDATED: 'updated',
  STATUS_CHANGED: 'status_changed',
  ASSIGNEE_CHANGED: 'assignee_changed',
  COMMENT_ADDED: 'comment_added',
  LINK_ADDED: 'link_added',
  TEST_RUN_LINKED: 'test_run_linked',
  CLOSED: 'closed'
}

// Export plural aliases for backward compatibility
export const FEATURE_STATUSES = FEATURE_STATUS
export const FEATURE_PRIORITIES = FEATURE_PRIORITY
export const FEATURE_STATUS_OPTIONS_LIST = FEATURE_STATUS_OPTIONS
export const FEATURE_PRIORITY_OPTIONS_LIST = FEATURE_PRIORITY_OPTIONS
